// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1iLiV","inputWrap":"CustomTip_inputWrap__kBWSX"};